// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router/index.js";
import Scrollspy from "vue2-scrollspy";
import VueScrollTo from "vue-scrollto";

Vue.use(Scrollspy);
Vue.use(VueScrollTo);

Vue.config.productionTip = false;

let apiDomainURL = "https://webershandwick.co.uk/";
// let apiDomainURL = "https://weber.flipside-staging.com/";
let apiDomainLang = "en";

if (typeof weber_api !== "undefined") {
  apiDomainURL = weber_api;
}
if (typeof weber_api_lang !== "undefined") {
  apiDomainLang = weber_api_lang;
}

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router: router(apiDomainLang),
  data: {
    headeriswhite: false,
    headerIsVisible: true,
    smallFooter: false,
    dataReady: false,
    menuOpen: false,
    apiUrl: apiDomainURL,
    apiLang: apiDomainLang,
  },
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js